import React from 'react';
import Locale from "./components/Locale";

function Offline(props){
    return (
        <div id="offline">
            <div className="icon">Offline</div>
            <div className="message" dangerouslySetInnerHTML={{__html: Locale.offline.message}} />
        </div>    
    );
}

export default Offline;